import { render, staticRenderFns } from "./VideoCallIncomingContainer.vue?vue&type=template&id=a5d689ec&scoped=true&"
import script from "./VideoCallIncomingContainer.vue?vue&type=script&lang=ts&"
export * from "./VideoCallIncomingContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d689ec",
  null
  
)

export default component.exports